import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import TreeGridItem from './item';
export default forwardRef(function TreeGridCell(_ref, ref) {
  var children = _ref.children,
      _ref$withoutGridItem = _ref.withoutGridItem,
      withoutGridItem = _ref$withoutGridItem === void 0 ? false : _ref$withoutGridItem,
      props = _objectWithoutProperties(_ref, ["children", "withoutGridItem"]);

  return createElement("td", _extends({}, props, {
    role: "gridcell"
  }), withoutGridItem ? children : createElement(TreeGridItem, {
    ref: ref
  }, children));
});
//# sourceMappingURL=cell.js.map